import { gql, useQuery } from '@apollo/client'
import {
  BooleanInput,
  email,
  minLength,
  PasswordInput,
  required,
  SelectInput,
  TextInput,
} from 'react-admin'

// nhost's own roles, which only exist for its internals: `me` is granted to
// every account automatically, `anonymous` is for anonymous sign-in (disabled).
const INTERNAL_ROLES = ['me', 'anonymous']

// Matches the check in public.crm_create_user / crm_set_password.
const PASSWORD = [minLength(12)]

export const UpsertUser = ({ create = false }) => {
  const { data } = useQuery(gql`
    {
      authRoles {
        role
      }
    }
  `)
  const roles = (data?.authRoles ?? [])
    .filter(({ role }) => !INTERNAL_ROLES.includes(role))
    .map(({ role }) => ({ id: role, name: role }))

  return (
    <>
      <TextInput
        fullWidth
        source='email'
        type='email'
        validate={[required(), email()]}
        label='resources.users.fields.email'
      />
      <TextInput fullWidth source='displayName' label='resources.users.fields.username' />
      <SelectInput
        source='defaultRole'
        choices={roles}
        validate={[required()]}
        label='resources.users.fields.role'
      />
      <PasswordInput
        source='password'
        validate={create ? [required(), ...PASSWORD] : PASSWORD}
        label={create ? 'resources.users.fields.password' : 'resources.users.fields.new_password'}
        helperText={create ? false : 'resources.users.fields.new_password_hint'}
      />
      {!create && <BooleanInput source='disabled' label='resources.users.fields.disabled' />}
    </>
  )
}

export default UpsertUser
